import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import PickupSettingSavePage from '@components/common/page/pickupSetting/PickupSettingSavePage';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { getData, setData } from '@utils/localStorage';
import { Tabs } from 'antd';

import Device from './device/Device';

const PickUpDeviceTabPage = () => {
    const translate = useTranslate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const deviceId = searchParams.get('deviceId');
    const deviceName = searchParams.get('deviceName');
    const collapseId = searchParams.get('collapseId');

    const [activeTab, setActiveTab] = useState(() => {
        const savedTab = getData(routes.listOrderDeviceTabPage.keyActiveTab);
        return savedTab || 'device';
    });

    return (
        <PageWrapper
            routes={[
                { breadcrumbName: translate.formatMessage(commonMessage.managerOrderDisplay), path: collapseId ? `${routes.listOrderDevicePage.path}?collapseId=${collapseId}` : routes.listOrderDevicePage.path },
                { breadcrumbName: deviceName },
            ]}
        >
            <ListPage
                baseTable={
                    <>
                        <Tabs
                            type="card"
                            destroyInactiveTabPane
                            onTabClick={(key) => {
                                if (key === activeTab) return;
                                setActiveTab(key);
                                setData(routes.deviceTabsRestaurantListPage.keyActiveTab, key);
                            }}
                            activeKey={activeTab}
                            items={[
                                {
                                    key: 'device',
                                    label: translate.formatMessage(commonMessage.Device),
                                    children: <Device deviceId={deviceId}/>,
                                },
                                {   
                                    key: 'setting-device',
                                    label: translate.formatMessage(commonMessage.setting),
                                    children: <PickupSettingSavePage deviceId={deviceId}/>,
                                },
                            ]}
                        />
                    </>
                }
            />
        </PageWrapper>
    );
};

export default PickUpDeviceTabPage;
